import api from '../../utils/api';
import history from '../../utils/history';
import { alertSuccess, alertError } from './alert';
import { SET_LOADING } from './supplierInventory';

let cancelExport;
export const exportProducts = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_LOADING, payload: { export: true } });
    if (cancelExport) {
      cancelExport('Cancel products export');
    }

    const { supplierId } = getState().role;
    const response = await api.get(`/suppliers/${supplierId}/variants?csv=true`, {
      cancelToken: new api.CancelToken((c) => (cancelExport = c)),
    });

    if (response && response.status === 200 && response.data === 'OK') {
      dispatch(
        alertSuccess(
          [
            'Your products report is being emailed to you and will soon be available on the',
            <button key="reports-page-link" onClick={() => history.push(`/suppliers/${supplierId}/analytics/reports`)}>
              Reports page
            </button>,
          ],
          false,
        ),
      );
    }
  } catch (error) {
    dispatch(alertError(error));
  } finally {
    dispatch({ type: SET_LOADING, payload: { export: false } });
  }
};
